import { motion } from 'framer-motion';
import styled from 'styled-components';

export const PeopleSearchWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  border-radius: 8px;
  background: ${({ theme }) => (theme.currentStep === 1 && !theme.isLoading ? '#ffffff' : 'none')};
  box-shadow: 5px 0px 20px -10px rgba(50, 63, 93, 0.1);

  ${({ theme }) =>
    theme.currentStep !== 1 &&
    `
    align-self: center;
  `}

  z-index: 99;

  position: relative;
`;

// TABLET BACKGROUND
export const PeopleSearchTabletBackgroundWrapper = styled(motion.div).attrs({
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
})`
  width: 100%;
  height: 100%;

  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(2px);

  z-index: 1000;
`;
